import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconLogo = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 30 32" fill="none">
    <path
      d="M11.424 32H22.176L16.8 22.496L14.112 27.248L14.064 27.312L11.424 32Z"
      fill="url(#paint0_linear_287_1204)"
    />
    <path
      d="M29.536 0L26.736 4.944L26.512 5.328L23.68 10.352L23.504 10.656L20.608 15.76L20.48 16L17.552 21.184L16.8 22.496L11.424 32H11.408L9.79201 29.12L11.184 26.672L11.232 26.592L14.208 21.328L14.288 21.184L17.232 16L17.36 15.76L20.24 10.656L20.416 10.352L23.264 5.328L23.488 4.944L26.288 0H29.536Z"
      fill="url(#paint1_linear_287_1204)"
    />
    <path
      d="M24.256 0L21.456 4.944L21.232 5.328L18.384 10.352L18.208 10.656L15.312 15.76L15.184 16L12.256 21.184L12.176 21.328L9.184 26.592L9.152 26.672L8.768 27.328L7.136 30.208L6.128 32L3.104 26.672L3.056 26.592L0.08 21.328L0 21.184L2.928 16L3.056 15.76L5.952 10.656L6.128 10.352L8.976 5.328L9.184 4.944L11.984 0H24.256Z"
      fill="url(#paint2_linear_287_1204)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_287_1204"
        x1="13.7609"
        y1="26.6473"
        x2="19.1586"
        y2="35.9595"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5D01D0" />
        <stop offset="0.532" stopColor="#C725FF" />
        <stop offset="1" stopColor="#EC00FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_287_1204"
        x1="12.0794"
        y1="2.6495"
        x2="26.4705"
        y2="25.5258"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#430078" />
        <stop offset="0.2927" stopColor="#6100DC" />
        <stop offset="0.6769" stopColor="#C725FF" />
        <stop offset="1" stopColor="#EC00FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_287_1204"
        x1="3.52642"
        y1="-2.53416"
        x2="21.5166"
        y2="26.0632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#430078" />
        <stop offset="0.2927" stopColor="#6100DC" />
        <stop offset="0.6769" stopColor="#C725FF" />
        <stop offset="1" stopColor="#EC00FF" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
